<template>
  <footer class="footer">
    <div class="container">
      <div class="content">
        <div class="columns">
          <div class="column">
            <p>{{ $t("footer.slogan") }}</p>
            <p>{{ $t("footer.data") }} <span class="mdi mdi-emoticon-happy"></span></p>
            <p>{{ $t("footer.contact") }} : <a href="mailto:gobeletpong@gmail.com">gobeletpong@gmail.com</a></p>
          </div>
          <div class="column">
            <SocialIcons/>
          </div>
          <div class="column is-one-fifth">
            <SwitchLanguage/>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SwitchLanguage from '@/components/SwitchLanguage'
import SocialIcons from '@/components/SocialIcons'
export default {
  components: {
    SwitchLanguage,
    SocialIcons
  }
}
</script>

<style scoped>
  footer {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue